<template>
  <v-autocomplete
    v-model="item"
    :items="items"
    :loading="isLoading"
    :error-messages="error"
    :search-input.sync="searchTerm"
    label="Empresa"
    item-text="name"
    item-value="id"
    clearable
    outlined
    dense
    no-filter
    @input="$emit('input', item)"
  />
</template>

<script>
  import companyService from '@/services/empresa.service';

  export default {
    name: 'SearchOrderCompanySelect',

    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data: () => ({
      isLoading: false,
      error: null,
      items: [],
      item: null,
      searchTerm: '',
      searchDebounceTimer: null,
    }),

    watch: {
      searchTerm(value) {
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = setTimeout(() => {
          this.fetch(value);
        }, 400);
      }
    },

    mounted() {
      this.item = this.value;
      this.fetch('');
    },

    methods: {
      fetch(name) {
        this.isLoading = true;
        this.error = null;
        companyService.search({ name }).subscribe({
          next: ({ items }) => {
            this.items = items;
            this.isLoading = false;
          },
          error: () => {
            this.error = 'Erro ao carregar as empresas';
            this.isLoading = false;
          }
        });
      },
    }
  };
</script>
